import Carousel from "react-bootstrap/Carousel";
import "./slider.css";
import MainLine from "../img/majorProducts/Main Lt Distribution Panel.png";
import MeterPanel from "../img/majorProducts/Meter PANEL img.png";
import PLCPanel from "../img/majorProducts/PLC AUTOMATION PANEL.png";
import PowerFActorPanel from "../img/majorProducts/power factor.png";
import { Container } from "react-bootstrap";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { useNavigate } from "react-router-dom";

function Slider() {
  useGSAP(() => {
    let t2 = gsap.timeline();
    t2.from(".slider-heading", {
      x: 100,
      duration: 0.7,
      opacity: 0,
    });
    t2.from(".slider-p-gsap", {
      y: 100,
      duration: 0.7,
      opacity: 0,
    });
    t2.from(".slider-img", {
      x: -100,
      duration: 0.7,
      opacity: 0,
    });
  });

  const data = [
    {
      "_id": "686a6ff38b57bc96a92d9e2b",
      heading: (
        <>
          M<span className="heading-span">AIN</span> L
          <span className="heading-span">INE</span> L
          <span className="heading-span">T</span> P
          <span className="heading-span">ANEL</span>
        </>
      ),
      
      desc: `The Main Line LT Panel serves as the central hub of power distribution, delivering electricity safely and efficiently from the transformer to various equipment and sub-panels. Designed with robust construction and advanced protection features, it ensures smooth operation, overload protection, and uninterrupted power supply. Our LT panels are engineered to handle high electrical loads with precision, making them ideal for industrial, commercial, and residential applications.`,
       img: MainLine,
    },
    {
       "_id":"686a6fca8b57bc96a92d9e27",
      heading: (
        <>
          PLC A<span className="heading-span">UTOMATION</span> P
          <span className="heading-span">ANEL</span>
        </>
      ),
desc:`Our PLC Automation Panels are engineered to provide smart, reliable, and efficient control solutions for a wide range of industrial processes. Designed with advanced PLC technology, these panels ensure seamless automation, precise monitoring, and improved productivity. From small machinery control to large-scale industrial automation, our panels are customized to meet specific application needs with flexibility and accuracy.` ,
     img: PLCPanel,
    },
    {
        "_id":"686a6d1b8b57bc96a92d9e1f",
      heading: (
        <>
       M<span className="heading-span">ETER</span> P
          <span className="heading-span">ANEL</span>
        </>
      ),
      desc:`Our Meter Panels are designed to deliver reliable, accurate, and safe power distribution. Built with high-quality components, they ensure precise monitoring, easy accessibility, and long-lasting performance—whether it’s for a small building or a high-rise complex. With our Meter Panels, you can seamlessly monitor power consumption and manage distribution with complete confidence.`,
       img: MeterPanel,
    },
    {
      "_id": "686a6fe48b57bc96a92d9e29",
      heading: (
        <>
          P<span className="heading-span">OWER</span> F
          <span className="heading-span">ACTOR</span> P
          <span className="heading-span">ANEL</span>
        </>
      ),
      desc: `Our Power Factor Panels are designed to improve energy efficiency, reduce electricity costs, and ensure reliable power quality in industrial and commercial setups. By automatically managing and correcting the power factor, these panels minimize energy losses, enhance system performance, and prevent penalties from utility providers.`,
      img: PowerFActorPanel,
    },
  ];

    const navigate = useNavigate();
    const NaviagteDetail = (id) => {
      navigate(`/detailPage/${id}`);
    };
  return (
    <>
      <section className="SliderPage">
        <Container>
          <Carousel>
            {data.map((item, index) => (
              <Carousel.Item key={index} interval={2000}>
                <div className="row carousel-container h-100">
                  <div className="col-sm-12 col-md-6 order-md-1 order-2 align-items-center d-flex h-100">
                    <div>
                      <div className="position-relative heading-container ">
                        <h2 className="heading slider-heading">{item.heading}</h2>
                        <div className="line"></div>
                      </div>
                      <p className="slider-p slider-p-gsap h-100">{item.desc}</p>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-5 order-md-2 order-1 d-flex align-items-center justify-content-center h-100 slider-img-container">
                    <img src={item.img} className="w-100 slider-img" alt="panel" onClick={()=>{NaviagteDetail(item._id)}}/>
                  </div>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </Container>
      </section>
    </>
  );
}

export default Slider;
